// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OtherProfile_profile__EXeoN {
  margin-bottom: 20px;
}
.OtherProfile_profile__EXeoN .OtherProfile_info__c\\+U8i {
  display: flex;
}
.OtherProfile_profile__EXeoN .OtherProfile_info__c\\+U8i img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 5px;
  margin-right: 5px;
}
.OtherProfile_profile__EXeoN .OtherProfile_info__c\\+U8i .OtherProfile_title__JWOEh {
  display: flex;
  flex-direction: column;
}
.OtherProfile_profile__EXeoN .OtherProfile_info__c\\+U8i .OtherProfile_title__JWOEh .OtherProfile_title-name__fsa6C {
  font-size: 14px;
  font-weight: 600;
  color: var(--explore-color);
}
.OtherProfile_profile__EXeoN .OtherProfile_info__c\\+U8i .OtherProfile_title__JWOEh .OtherProfile_title-institution__NGsa2 {
  font-size: 12px;
}
.OtherProfile_profile__EXeoN .OtherProfile_info__c\\+U8i .OtherProfile_title__JWOEh .OtherProfile_title-position__ev8G8 {
  font-size: 12px;
}
.OtherProfile_profile__EXeoN .OtherProfile_citation__nZwcs p {
  font-size: 12px;
  font-weight: 600;
}
.OtherProfile_profile__EXeoN .OtherProfile_citation__nZwcs .OtherProfile_button__j2iKl {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.OtherProfile_profile__EXeoN .OtherProfile_citation__nZwcs .OtherProfile_button__j2iKl button {
  cursor: pointer;
  padding: 5px 10px;
  color: var(--explore-color);
  border-radius: 5px;
  border: 1px solid var(--explore-color);
  font-size: 12px;
  background: white;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/FacultyDetail/Components/OtherProfile/OtherProfile.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAAE;EACE,aAAA;AAEJ;AADI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAGN;AADI;EACE,aAAA;EACA,sBAAA;AAGN;AAFM;EACE,eAAA;EACA,gBAAA;EACA,2BAAA;AAIR;AAFM;EACE,eAAA;AAIR;AAFM;EACE,eAAA;AAIR;AACI;EACE,eAAA;EACA,gBAAA;AACN;AACI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AACN;AAAM;EACE,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,kBAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;AAER","sourcesContent":[".profile {\n  margin-bottom: 20px;\n  .info {\n    display: flex;\n    img {\n      width: 60px;\n      height: 60px;\n      object-fit: cover;\n      border-radius: 5px;\n      margin-right: 5px;\n    }\n    .title {\n      display: flex;\n      flex-direction: column;\n      .title-name {\n        font-size: 14px;\n        font-weight: 600;\n        color: var(--explore-color);\n      }\n      .title-institution {\n        font-size: 12px;\n      }\n      .title-position {\n        font-size: 12px;\n      }\n    }\n  }\n  .citation {\n    p {\n      font-size: 12px;\n      font-weight: 600;\n    }\n    .button {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n      button {\n        cursor: pointer;\n        padding: 5px 10px;\n        color: var(--explore-color);\n        border-radius: 5px;\n        border: 1px solid var(--explore-color);\n        font-size: 12px;\n        background: white;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profile": `OtherProfile_profile__EXeoN`,
	"info": `OtherProfile_info__c+U8i`,
	"title": `OtherProfile_title__JWOEh`,
	"title-name": `OtherProfile_title-name__fsa6C`,
	"title-institution": `OtherProfile_title-institution__NGsa2`,
	"title-position": `OtherProfile_title-position__ev8G8`,
	"citation": `OtherProfile_citation__nZwcs`,
	"button": `OtherProfile_button__j2iKl`
};
export default ___CSS_LOADER_EXPORT___;
